<div>
  <ng-container *ngIf="!channel?.id">
    <ion-button fill="outline" (click)="openModal()" [disabled]="disabled">
      <ion-icon name="unlink-outline" class="icon-padded"></ion-icon>
      {{ initialButtonText }}
    </ion-button>
  </ng-container>
  <ng-container *ngIf="channel?.id">
    <ion-button color="light" (click)="openModal()" [disabled]="disabled">
      <ion-icon name="link-outline" class="icon-padded"></ion-icon>
      <span>{{ getDisplayText() }}</span>
    </ion-button>
    <ion-button
      color="dark"
      fill="clear"
      (click)="clearSelection()"
      [hidden]="hideUnlinkButton"
      [disabled]="disabled"
    >
      Unset
    </ion-button>
  </ng-container>
</div>
